import React from 'react';
import AsyncSelect from 'react-select/async';
import { FormGroup, Label } from 'reactstrap';

const SearchDropdown = ({
  className,
  disabled,
  id,
  label,
  loadOptions,
  name,
  onChange,
  placeholder,
  required,
  value,
}: {
  className?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
  loadOptions: any;
  name?: string;
  onChange: any;
  placeholder: string;
  required?: boolean;
  value: any;
}): JSX.Element | null => {
  const ctrlKey = 17;
  const cKey = 67;

  const [ctrlDown, setCtrlDown] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  const handleKeyDownEvent = (event: any) => {
    if (!focused) {
      setCtrlDown(false);
      return;
    }

    if (event.keyCode === ctrlKey) {
      setCtrlDown(true);
    }

    if (ctrlDown && event.keyCode === cKey) {
      navigator.clipboard.writeText(value.label);
    }
  };

  const handleKeyUpEvent = (event: any) => {
    setCtrlDown(false);
  };

  return (
    <FormGroup>
      {label === undefined ? null : (
        <Label className="label" for={id}>
          {label}
        </Label>
      )}
      <AsyncSelect
        className={`text-field search-field ${className}`}
        id={id}
        isClearable
        oncopy={handleKeyDownEvent}
        onKeyDown={handleKeyDownEvent}
        onKeyUp={handleKeyUpEvent}
        onFocus={onFocus}
        onBlur={onBlur}
        isDisabled={disabled}
        loadOptions={loadOptions}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        value={value}
      />
    </FormGroup>
  );
};

export default SearchDropdown;
